// The points the map draws for the experiences of the list.
export const getExperiencePoints = (experiences?: any[]): any[] =>
  (experiences ?? [])
    .filter(
      (experience) =>
        experience?.inCity?.lat != null && experience?.inCity?.lon != null,
    )
    .map((experience) => ({
      ...experience,
      id: experience?.id,
      title: experience?.name,
      lat: experience?.inCity?.lat,
      lon: experience?.inCity?.lon,
      type: experience?.transferType || experience?.experienceType,
    }));

// Coordinates shared by several points: they collapse into one marker that
// opens a slider of all of them.
export const getDuplicateCoords = (points?: any[]): Set<string> =>
  new Set(
    (points ?? [])
      .map(({ lat, lon }) => `${lat},${lon}`)
      .filter((coord, _, arr) => arr.indexOf(coord) !== arr.lastIndexOf(coord)),
  );
